require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/assign.js
// module id = 1436
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16